export const SIGNOUT_REQUEST = "SIGNOUT_REQUEST";

export const signOutRequest = () => ({
    type: SIGNOUT_REQUEST,
});